export default __webpack_public_path__ + "static/media/GPA_Banner_Educational_Resources.f2c4e608.png";